import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { v4 as uuidv4 } from 'uuid';
import * as CryptoJS from 'crypto-js';
import * as moment from 'moment';

import { jwt } from '../../../environments/environment';

import { SessionStorageService } from './session.service';

@Injectable({
  providedIn: 'root'
})

export class JWTService {
  constructor(
    private http: HttpClient,
    private sessionService: SessionStorageService
  ) { }

  private jwt: any = {};

  // Generate JWT Token
  generateJWTToken(keyId) {
    let uuid = uuidv4();
    const header = {
      alg: "HS256",
      typ: "JWT"
    };
    const data = {
      token_use: 'id',
      jti: String(uuid),
      keyid: keyId
    };

    const token = this.getToken(header, data);
    uuid = uuid.concat('function()');

    const cryptoEnc = CryptoJS.SHA256(uuid);
    uuid = CryptoJS.enc.Hex.stringify(cryptoEnc);

    return {
      uuidVal: uuid,
      accessToken: token
    };
  }

  // Get Token
  getToken(header, data): any {
    const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
    const encodedHeader = this.base64url(stringifiedHeader);

    const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
    const encodedData = this.base64url(stringifiedData);

    const token = encodedHeader + "." + encodedData;

    const signature = CryptoJS.HmacSHA256(token, 'const');
    const encodedsignature = this.base64url(signature);

    const signedToken = token + "." + encodedsignature;

    return signedToken;
  }

  // Add key to cache
  addKeyToCache(key): Observable<any> {
    const URL = jwt.authorizeURL;
    return this.http.post(URL, { idToken: key });
  }

  // Below not optimised

  getJWT() {
    return this.jwt;
  }



  base64url(source) {
    var encodedSource = CryptoJS.enc.Base64.stringify(source);

    encodedSource = encodedSource.replace(/=+$/, '');

    encodedSource = encodedSource.replace(/\+/g, '-');
    encodedSource = encodedSource.replace(/\//g, '_');

    return encodedSource;
  }


  addHashToCache(keyId): Observable<any> {

    let uuid_val = uuidv4();
    const header = {
      alg: "HS256",
      typ: "JWT"
    };
    const data = {
      token_use: 'id',
      jti: String(uuid_val),
      keyid: keyId,
      expires: moment().add(30, 'minutes').toISOString()
    };
    const token = this.getToken(header, data);

    uuid_val = uuid_val.concat('function()');
    var uuid_val1 = CryptoJS.SHA256(uuid_val);
    uuid_val = CryptoJS.enc.Hex.stringify(uuid_val1);

    const isAdded = this.addKeyToCache(uuid_val);

    if (isAdded) {
      this.sessionService.setItemIntoMemory('access_token', true);
      this.jwt = token;
      return of({ hash: token });
    } else
      return of({ hash: undefined });
  }
}
